import type { Channel } from 'stream-chat'
import type { StreamChatGenerics } from '../types'

/**
 * Determines if a channel is a group chat or a 1-1 chat.
 *
 * This function first checks for the `isGroup` metadata flag (preferred approach).
 * If the flag is not present, it falls back to checking member count for backward compatibility.
 *
 * @param channel - The Stream Chat channel to check
 * @returns true if the channel is a group chat, false if it's a 1-1 chat
 */
export const isGroupChannel = (channel: Channel<StreamChatGenerics> | any): boolean => {
  // First check metadata flag (new approach)
  if (typeof channel.data?.isGroup === 'boolean') {
    return channel.data.isGroup
  }

  // Fallback to member count for existing channels without metadata
  // Get all members and count those who aren't the current user
  const allMembers = Object.values(channel.state.members || {})
  // For backward compatibility, we check if there are more than 2 total members
  // (which means more than 1 other member besides the current user)
  return allMembers.length > 2
}
